import { createSelector } from "@reduxjs/toolkit";

import type { IShopRootState } from "../../../types";
import type { IOrderReducerState } from "../types";

export const orderStateSelector = (state: IShopRootState): IOrderReducerState => state.shopping.order;

// sparepart assembly

const sparepartAssemblyStateSelector = createSelector(orderStateSelector, (state) => state.sparepartAssembly);

export const getSparepartAssemblyIsModalOpen = createSelector(sparepartAssemblyStateSelector, (state) => state.isModalOpen);

export const getSparepartAssemblyModalPositionId = createSelector(sparepartAssemblyStateSelector, (state) => state.modalPositionId);

export const getSparepartAssemblyModalCurrentData = createSelector(sparepartAssemblyStateSelector, (state) => ({
  modalComment: state.modalComment,
  modalEarliestDate: state.modalEarliestDate,
  modalRequestedDate: state.modalRequestedDate
}));

export const getSparepartAssemblyPositions = createSelector(sparepartAssemblyStateSelector, (state) => state.positions);

export const hasSparepartAssemblyPositions = createSelector(sparepartAssemblyStateSelector, (state) => Object.keys(state.positions).length > 0);
